module.exports = __webpack_public_path__ + "img/352091.4fba0633.jpg";